module.exports = __webpack_public_path__ + "components/breakheader/static/icon--s4-9a2c03d2a532add50b0694fb9dac760b.svg";